import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "react-router-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore } from "redux-persist";

import combinedReducer from "./reducer";

export const history = createBrowserHistory();
const navMiddleware = routerMiddleware(history);

const store = createStore(
  combinedReducer,
  composeWithDevTools(applyMiddleware(thunk, navMiddleware))
);

export const makePersist = (callback) => persistStore(store, null, callback); // const persistor = persistStore(store);

/*export*/ export default store;
